import { render, staticRenderFns } from "./FrameworkHome.vue?vue&type=template&id=2517173a"
import script from "./FrameworkHome.vue?vue&type=script&lang=js"
export * from "./FrameworkHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports